module.exports = __webpack_public_path__ + "img/no_history.86431c1f.svg";